import { useEffect, useState } from "react";

/**
 * True while another day loads over the rows of the one on screen, so they can be covered by a loader.
 * A background refresh of the same day stays quiet.
 */
export const useDayChangeLoader = ({ date, isLoading, isRefreshing, hasRows, failed }: {
  date: Date;
  isLoading: boolean;
  isRefreshing: boolean;
  hasRows: boolean;
  failed: boolean;
}): boolean => {
  const dayKey = date.toDateString();
  // The day whose rows are on screen.
  const [shownDay, setShownDay] = useState(dayKey);
  useEffect(() => {
    if (!isLoading && !isRefreshing) setShownDay(dayKey);
  }, [dayKey, isLoading, isRefreshing]);
  return hasRows && !failed && dayKey !== shownDay && (isLoading || isRefreshing);
};
